module.exports = __webpack_public_path__ + "img/icon36.a217b3da.png";